// https://stackoverflow.com/questions/35623656/how-can-i-display-a-modal-dialog-in-redux-that-performs-asynchronous-actions/35641680#35641680

import React from 'react';
import { connect } from 'react-redux';

import ModalComponent from 'components/ModalComponent';

import FinancialSplitModal from './billing/FinancialSplitModal';
import DataRetention from './setup/DataRetention';
import ContractGeneration from './admin_portal/BulkContractCreation/ContractGeneration';
import ContractGenerationVerification from './admin_portal/BulkContractCreation/ContractGenerationVerification';
import CounterSignatureModal from './admin_portal/CounterSignatureModal';
import registeredComponent from '../utils/registeredComponent';
import {
  MessageModal, UnexpectedError, VerificationModal, ExplicitVerificationModal
} from './DefaultModals';
import BulkActionEventModal from './BulkActionEventModal';
import ManualPaymentModal from './checklist_items/ManualPaymentModal';
import SplitDepositManualPaymentModal from './checklist_items/SplitDepositManualPaymentModal';
import Downloader from './Downloader';
import SsatbComponentEditor from './setup/SsatbComponentEditor';
import SsatbFieldEditor from './setup/SsatbFieldEditor';
import ChecklistAnswerLinker from './parent_portal/ChecklistAnswerLinker';
import ChecklistAnswerUnlinker from './parent_portal/ChecklistAnswerUnlinker';
import BasicChecklistCompletionModal from './parent_portal/BasicChecklistCompletionModal';
import EmbedFormModal from './setup/EmbedFormModal';
import RefundForm from 'components/refunds/RefundForm';
import FieldEditor from 'components/form_editing/FieldEditor';
import PageEditor from 'components/form_editing/PageEditor';

import ContractSubmission from './admin_portal/BulkContractCreation/ContractSubmission';
import AuditViewer from './AuditViewer/AuditViewer';
import FeeChangeConfirmationModal from './FeeChangeConfirmationModal/FeeChangeConfirmartionModal';
import MoreInfo from './SharedPortal/studentSelector/MoreInfo';
import ApplyNow from './SharedPortal/studentSelector/ApplyNow';
import ChangeColumnsEditor from "./search/ChangeColumnsEditor";

/**
 * Registry of modal components, e.g. "ModalClass" -> ModalClass.
 *
 * If the modal class is not registered here then some other component assumes the responsibility of displaying it.
 */
const MODAL_COMPONENTS = {
  FinancialSplitModal,
  ContractGeneration,
  ContractGenerationVerification,
  DataRetention,
  UnexpectedError,
  MessageModal,
  BulkActionEventModal,
  ManualPaymentModal,
  SplitDepositManualPaymentModal,
  Downloader,
  VerificationModal,
  ExplicitVerificationModal,
  SsatbComponentEditor,
  SsatbFieldEditor,
  ChecklistAnswerLinker,
  ChecklistAnswerUnlinker,
  BasicChecklistCompletionModal,
  RefundForm,
  EmbedFormModal,
  CounterSignatureModal,
  FieldEditor,
  PageEditor,
  ContractSubmission,
  AuditViewer,
  FeeChangeConfirmationModal,
  MoreInfo,
  ApplyNow,
  ChangeColumnsEditor
};

const ModalRoot = ({ stack, modals = MODAL_COMPONENTS, props = {} }) => {
  if (!stack.length) {
    return null;
  }

  const { modalType, modalProps } = stack[0];
  const ModalComponent = modals[modalType];

  if (ModalComponent) {
    return <ModalComponent {...props} {...modalProps} />;
  }

  return null;
};

export default registeredComponent('ModalRoot')(connect(state => state.modals)(ModalRoot));
